import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';

import TileList from './TileList';

const StyledTileListContainer = styled.div``;
class DroppableColumn extends React.Component {
  render() {
    return (
      <Droppable droppableId={this.props.columnId} direction="horizontal">
        {(provided, snapshot) => (
          <StyledTileListContainer
            ref={provided.innerRef}
            {...provided.droppableProps}
            showStats={this.props.showStats}
          >
            <TileList {...this.props} tiles={this.props.tiles} />
            {provided.placeholder}
          </StyledTileListContainer>
        )}
      </Droppable>
    );
  }
}

DroppableColumn.propTypes = {
  columnId: PropTypes.string.isRequired,
  tiles: PropTypes.array,
  showStats: PropTypes.bool,
};

DroppableColumn.defaultProps = {
  showStats: false,
};

export { DroppableColumn };
